import { Option } from "../../util/option";
import { GetUserRolesResponse, UserRoleInfo } from "../../services/user-roles";

import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";

export type UserRoleMaintenancePageState = {
  searchResult: {
    getUserRolesResp?: GetUserRolesResponse;
  };
  spreadsheetSelectedRowIndex?: number;
  dataList?: DataList;
  displayColumn: DisplayColumn[];
};

export type SpreadsheetState = {
  userRoleInfoList: UserRoleInfoRow[];
  dataList: DataList;
};

export type UserRoleInfoRow = {
  addFlg: string;
  delCheckBox: boolean;
  userRoleInfo: UserRoleInfo;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type UserRoleInfoKeys = keyof UserRoleInfo;

export type DataList = {
  inDefCommonFlagType?: Option[];
  dipRoleList?: Option[];
  cvrgCdList?: Option[];
};
export type PageNewState =
  | UserRoleMaintenancePageState
  | ((prevState: UserRoleMaintenancePageState) => UserRoleMaintenancePageState);
